const lang = {
  msgsaved: "Données enregistrées",
  email: "Email",
  email_or_username: "E-mail ou nom d'utilisateur",
  actions: "Actions",
  export: "Exporter",
  picture: "Image",
  title: "titre",
  created: "Date de création",
  previous: "Précédent",
  next: "Suivant",
  edit: "Modifier",
  delete: "Supprimer",
  page: "Page",
  loading: "Chargement",
  order: "Commande",
  event: "Événement",
  date: "Date",
  day: "Jour",
  paid: "Payé",
  amount: "Montant",
  invoicedate: "Date de facturation",
  invoicenumber: "Numéro de facture",
  profilepicture: "Photo de profil",
  phone: "Téléphone",
  name: "Nom",
  username: "Utilisateurs",
  type: "Type",
  note: "Note",
  pendingpayment: "Paiement en attente",
  amounttype: "Type de montant",
  information: "Information",
  save: "Enregistrer",
  select: "Sélectionner",
  address: "Adresse",
  fromtime: "De",
  totime: "À",
  accounttype: "Type de compte",
  paymenttype: "Type de paiement",
  paymentamounttype: "Type de montant de paiement",
  time: "Heure",
  csv: "CSV",
  message: "Message",
  fullname: "Nom complet",
  password: "Mot de passe",
  registred: "Inscrit le",
  dob: "Date de naissance",
  registration: "Inscription",
  nationality: "Nationalité",
  sex: "Sexe",
  firstname: "Prénom",
  lastname: "Nom de famille",
  report: "Rapport",
  add: "Ajouter",
  home: "Accueil",
  lang: "Anglais",
  news: "Actualités",
  managergmgnet: "Administration",
  banner: "Logo",
  book: "Bibliothèque",
  uni: "Université",
  cal: "Calendrier",
  department: "Département",
  section: "Section",
  fees: "Frais",
  feestype: "Type de frais",
  classx: "Classes",
  agenda: "Agenda",
  uploadx: "Télécharger des fichiers",
  notx: "Notifications",
  maangx: "Manager",
  managtype: "Type de manager",
  cities: "Villes",
  client: "Client",
  branch: "Succursale",
  offer: "Offre",
  items: "Articles",
  subitems: "Sous-articles",
  jobs: "Emplois",
  service: "Service",
  baner: "Bannière",
  customeruser: "Utilisateur client",
  customervehicle: "Véhicule client",
  statusreason: "Raison du statut",
  appointmentThreshold: "Seuil de rendez-vous",
  fromToHours: "Heures de début à fin",
  minimumyear: "Année minimale",
  maxyear: "Année maximale",
  recipient: "Destinataire",
  template: "Modèle",
  notification: "Notification",
  link: "Lien",
  city: "Ville",
  country: "Pays",
  make: "Marque",
  model: "Modèle",
  trim: "Series",
  platecode: "Code de plaque",
  energytype: "Energies",
  platenumber: "N° plaque",
  vin: "N° Chassis",
  latitude: "Latitude",
  longitude: "Longitude",
  scope: "Portée",
  manager: "Manager",
  code: "Code",
  customer: "Client",
  vehicle: "Véhicule",
  arrivalmileage: "Kilométrage à l'arrivée",
  worker: "Personnel",
  driver: "Conducteur",
  driverphonenumber: "Numéro de téléphone du conducteur",
  images: "Images",
  workinghours: "Heures de travail",
  breaktime: "Pause",
  starttime: "Heure de début",
  endtime: "Heure de fin",
  firstday: "Premier jour",
  lastday: "Dernier jour",
  appointmentsfrequency: "Fréquence des rendez-vous",
  appointmentsperslot: "Rendez-vous par créneau",
  slotbookingthreshold: "Seuil de réservation de créneau",
  cities_management: "Gestion des villes",
  city_list: "Liste des villes",
  city_areas: "Zones de la ville",
  merchants_management: "Gestionnaire Mycar ",
  merchant: "Marchand",
  merchant_items: "Groupe Pièces Auto",
  merchant_subitems: "Pièces Auto",
  merchant_jobs: "Reception Voiture",
  merchant_workers: "Personnel KARAGI",
  merchant_users: "Utilisateurs",
  merchant_branch_details: "Détails de la succursale du marchand",
  merchant_branches: "Succursales du marchand",
  branch_services: "Services de la succursale",
  garage_services: "Services du garage",
  service_catalogue: "Catalogue de services",
  branch_photos: "Photos de la succursale",
  branch_ratings: "Évaluations de la succursale",
  appointments_management: "Gestion des rendez-vous",
  appointment_settings: "Paramètres de rendez-vous",
  appointments: "Rendez-vous",
  appointment_bookings: "Réservations de rendez-vous",
  setup: "Configuration",
  services: "Services",
  offers: "Offres",
  vehicles: "Véhicules",
  vehicles_management: "Gestion Automobiles",
  vehicle_makes: "Marques de véhicules",
  top_rated: "Les mieux notés",
  top_rated_rank: "Rang des mieux notés",
  application_setup: "Configuration de l'application",
  search_radius_km: "Rayon de recherche (km)",
  enable_reviews: "Activer les avis dans l'application",
  vehicle_models: "Modèles de véhicules",
  vehicle_model_trims: "Finition des modèles de véhicules",
  notifications: "Notifications",
  notifications_feed: "Fil de notifications",
  clear_notifications: "Effacer les notifications",
  delete_notification: "Supprimer la notification",
  confirm_clear_notifications: "Supprimer toutes les notifications ?",
  banners: "Bannières",
  users_management: "Gestion Clients",
  user_list: "Liste des utilisateurs",
  customers: "Clients",
  customer_users: "Clients",
  customer_vehicles: "Véhicules",
  add_city: "Ajouter une ville",
  edit_client: "Modifier le client",
  add_merchant: "Ajouter un marchand",
  edit_merchant: "Modifier le marchand",
  add_offer: "Ajouter une offre",
  edit_offer: "Modifier l'offre",
  add_merchant_items: "Ajouter des articles du marchand",
  edit_merchant_items: "Modifier les articles du marchand",
  add_merchant_subitems: "Ajouter des sous-articles du marchand",
  edit_merchant_subitems: "Modifier les sous-articles du marchand",
  add_merchant_jobs: "Ajouter des emplois du marchand",
  edit_merchant_jobs: "Modifier les emplois du marchand",
  add_merchant_branch_service: "Ajouter un service de succursale du marchand",
  edit_merchant_branch_service: "Modifier le service de succursale du marchand",
  add_merchant_branch_photo: "Ajouter une photo de succursale du marchand",
  edit_merchant_branch_photo: "Modifier la photo de succursale du marchand",
  add_merchant_branch_appointment_settings:
    "Ajouter les paramètres de rendez-vous de la succursale du marchand",
  edit_merchant_branch_appointment_settings:
    "Modifier les paramètres de rendez-vous de la succursale du marchand",
  add_appointment_booking:
    "Ajouter les paramètres de rendez-vous de la succursale du marchand",
  edit_appointment_booking:
    "Modifier les paramètres de rendez-vous de la succursale du marchand",
  add_vehicles_make: "Ajouter une marque de véhicule",
  edit_vehicles_make: "Modifier la marque de véhicule",
  add_vehicle_model: "Ajouter un modèle de véhicule",
  edit_vehicle_model: "Modifier le modèle de véhicule",
  add_vehicle_model_trim: "Ajouter une finition de modèle de véhicule",
  edit_vehicle_model_trim: "Modifier la finition de modèle de véhicule",
  add_notifications: "Ajouter des notifications",
  edit_notifications: "Modifier les notifications",
  add_services: "Ajouter des services",
  edit_services: "Modifier les services",
  add_areas: "Ajouter des zones",
  edit_areas: "Modifier les zones",
  add_banner: "Ajouter une bannière",
  edit_banner: "Modifier la bannière",
  edit_user: "Modifier l'utilisateur",
  add_user: "Ajouter un utilisateur",
  add_vehicle: "Ajouter un véhicule",
  edit_vehicle: "Modifier le véhicule",
  edit_merchantbranch: "Modifier la succursale du marchand",
  add_merchantbranch: "Ajouter une succursale du marchand",
  edit_merchantworker: "Modifier le personnel KARAGI",
  add_merchantworker: "Ajouter un personnel KARAGI",
  edit_merchantuser: "Modifier l'utilisateur du marchand",
  add_merchantuser: "Ajouter un utilisateur du marchand",
  login: "Connexion",
  logout: "Déconnexion",
  edit_manager_type: "Modifier le type de manager",
  add_manager_type: "Ajouter un type de manager",
  edit_manager: "Modifier le manager",
  add_manager: "Ajouter un manager",
  manager_type: "Type de manager",
  gasoline: "Essence",
  diesel: "Diesel",
  electric: "Electrique",
  hybrid: "Hybrid",
  occupation: "Occupation",
  subitem: "Sous-article",
  REGISTRATION: "Accueil",
  INSPECTION: "Garage",
  WAITING_FOR_APPROVAL: "En attente d'approbation",
  APPROVED: "Approuvé",
  REJECTED: "Rejeté",
  IN_PROGRESS: "En cours",
  TEST_DRIVE: "Test Drive",
  COMPLETED: "Complété",
  allowedjobstatuses: "Statuts de travail autorisés",
  saveandsendforapproval: "Enregistrer et envoyer pour approbation",
  sendfortestdrive: "Envoyer pour Test Drive",
  reject: "Reject",
  testdrivenote: "Test Drive Note",
  refresh: "Rafraîchir",
  price: "Prix",
  remark: "Remarque",
  branch_service_details: "Détails du Service",
  add_service_detail: "Ajouter Détail Service",
  edit_service_detail: "Modifier Détail Service",
  garages: "Garages",
  garage: "Garage",
  add_garage: "Ajouter un garage",
  search_garages: "Rechercher par nom, adresse, ville ou téléphone",
  no_garages: "Aucun garage trouvé",
  deactivate: "Désactiver",
  deactivated: "Désactivé",
  activate: "Réactiver",
  deactivated_garages: "Garages désactivés",
  deactivated_garages_subtitle: "Garages désactivés — leur personnel et leurs données sont conservés",
  back_to_active_garages: "Retour aux garages actifs",
  no_deactivated_garages: "Aucun garage désactivé",
  confirm_deactivate_garage: "Désactiver {0} ? Il disparaît de l'application et ne prend plus de travail. Son personnel, ses fiches et son historique sont conservés, et vous pourrez le réactiver.",
  confirm_activate_garage: "Réactiver {0} ? Il réapparaît dans l'application et peut de nouveau prendre du travail.",
  back_to_garages: "Retour aux garages",
  select_merchant_first: "Sélectionnez un marchand pour voir ses garages",
  photos: "Photos",
  ratings: "Évaluations",
  manage: "Gérer",
  cards_view: "Cartes",
  table_view: "Tableau",
  garage_count: "garage(s)",
  open: "Ouvrir",
  nodata: "Aucune donnée trouvée",
  area: "Zone",
  cancel: "Annuler",
  confirmdelete: "Êtes-vous sûr de vouloir supprimer ?",
  error: "Une erreur est survenue. Veuillez réessayer plus tard.",
  yes: "Oui",
  no: "Non",
  location: "Emplacement",
  search_location: "Rechercher une adresse ou un lieu",
  use_my_location: "Utiliser ma position actuelle",
  map_hint:
    "Cliquez sur la carte ou déplacez le marqueur pour définir l'emplacement du garage",
  garage_address_hint: "L'adresse est obligatoire (au moins 10 caractères)",
  garage_location_hint: "Choisissez l'emplacement du garage sur la carte",
  photos_after_save_hint:
    "Les photos sont téléversées une fois le garage enregistré",
  required_hint: "Ce champ est obligatoire",
  name_min_hint: "Le nom doit contenir au moins 2 caractères",
  price_min_hint: "Le prix ne peut pas être négatif",
  hours_required_hint: "Indiquez l'heure de début et de fin",
  threshold_min_hint: "Minimum 4",
  frequency_hint: "Minutes entre deux créneaux de rendez-vous",
  branch_service_form_hint: "Choisissez le service proposé par ce garage",
  photo_required_hint: "Choisissez au moins une image",
  photo_replace_hint: "Choisissez une image pour remplacer l'actuelle",
  photo_multi_hint: "Vous pouvez sélectionner plusieurs images à la fois",
  name_min3_hint: "Le nom doit contenir au moins 3 caractères",
  roles: "Rôles",
  roles_subtitle: "Modèles de permissions pour les comptes",
  user_access_subtitle: "Qui peut voir et modifier quoi",
  garages_subtitle: "Tous les ateliers de ce marchand",
  role: "Rôle",
  add_role: "Ajouter un rôle",
  permissions: "Permissions",
  permissions_required_hint: "Sélectionnez au moins une permission",
  default_for_garages: "Par défaut pour les garages",
  default_for_garages_hint:
    "Les nouveaux comptes garage démarrent avec les permissions de ce rôle",
  search_permissions: "Rechercher des permissions",
  clear_all: "Tout effacer",
  select_all: "Tout sélectionner",
  all_selected: "Tout sélectionné",
  can_view: "Voir",
  can_edit: "Modifier",
  user_access: "Accès utilisateurs",
  add_user_access: "Ajouter un utilisateur",
  edit_access: "Modifier l'accès",
  access: "Accès",
  all_garages: "Tous les garages",
  role_prefill_hint: "Choisir un rôle remplit les permissions ci-dessous",
  garage_pin_hint: "Limiter cet utilisateur à un seul garage",
  garage_login: "Compte du garage",
  garage_login_hint: "Le garage se connecte avec cet email",
  garage_role_hint: "Permissions accordées à ce compte garage",
  new_password: "Nouveau mot de passe",
  password_hint:
    "Au moins 8 caractères avec majuscule, minuscule, chiffre et symbole",
  password_change_hint: "Laissez vide pour garder le mot de passe actuel",
  email_hint: "Saisissez une adresse email valide",
  phone_min_hint: "Le numéro doit contenir au moins 8 chiffres",
  work_orders: "Ordres de travail",
  work_tracking: "Suivi des travaux",
  mark_all_read: "Tout marquer comme lu",
  payment_methods: "Moyens de paiement",
  payment_method: "Moyen de paiement",
  payment_methods_subtitle: "Liste fixe du système — activez ou désactivez un moyen de paiement pour les garages",
  active: "Actif",
  garage_setup: "Configuration du garage",
  no_garage_setup: "Ce garage n'est pas encore configuré",
  no_garage_setup_hint: "Configurez la devise, la TVA, les couleurs de livraison et les moyens de paiement acceptés",
  vat: "TVA",
  has_vat: "Ce garage facture la TVA",
  vat_percentage: "Pourcentage de TVA",
  vat_percentage_hint: "Requis si la TVA est activée",
  delivery_colors: "Couleurs de la date de livraison",
  delivery_colors_hint: "Heures restantes avant la livraison à partir desquelles chaque couleur s'affiche. La couleur la plus urgente qui s'applique l'emporte.",
  green_threshold_hours: "Vert — heures avant la livraison",
  yellow_threshold_hours: "Jaune — heures avant la livraison",
  red_threshold_hours: "Rouge — heures avant la livraison",
  accepted_payment_methods: "Moyens de paiement acceptés",
  currencies: "Devises",
  currency: "Devise",
  currencies_subtitle: "Les devises utilisées par les garages — ajoutez-en une et elle devient sélectionnable dans la configuration du garage",
  delivery_methods: "Modes d'arrivée",
  delivery_method: "Mode d'arrivée",
  delivery_methods_subtitle: "Comment un véhicule arrive au garage — la fiche de travail propose ceux qui sont actifs",
  add_delivery_method: "Ajouter un mode d'arrivée",
  delivery_method_name_hint: "Affiché tel quel au technicien, ex. Dépanneuse",
  delivery_method_active_hint: "Inactif : reste sur les anciennes fiches mais n'est plus proposé",
  display_order: "Ordre d'affichage",
  display_order_hint: "Le plus petit s'affiche en premier",
  delivery_method_asks_for: "Demande",
  delivery_method_asks_for_hint: "Ce qu'il faut noter quand un véhicule arrive ou part de cette façon",
  asks_nothing: "Rien",
  asks_person: "Le nom et le téléphone du chauffeur",
  asks_company: "Le nom d'une société",
  driver_name: "Nom du chauffeur",
  driver_phone: "Téléphone du chauffeur",
  recovery_company: "Société de dépannage",
  required_field: "Obligatoire",
  fuel_level: "Niveau de carburant",
  delivery_method_hint: "Comment le véhicule est arrivé au garage",
  no_delivery_methods_hint: "Aucun mode d'arrivée actif — ajoutez-en dans Configuration",
  how_is_car_leaving: "Véhicule à récupérer par",
  collection_method_hint: "Qui récupère le véhicule — les mêmes choix qu'à l'arrivée",
  arrived_by: "Arrivé par : {0}",
  collected_by: "Récupéré par : {0}",
  job_card_video: "Vidéo du tour du véhicule",
  job_card_video_hint: "Obligatoire — une courte vidéo autour du véhicule, 30 secondes maximum",
  job_card_video_required: "Ajoutez la vidéo pour ouvrir la fiche de travail",
  job_card_video_too_big: "Cette vidéo est trop lourde — moins de 64 Mo",
  job_card_photos_hint: "Facultatif",
  add_video: "Ajouter une vidéo",
  add_photos: "Ajouter des photos",
  job_card_media_failed: "La fiche a été ouverte, mais {0} fichier(s) n'ont pas été envoyés. Ils peuvent être ajoutés depuis l'application.",
  go_to_job_cards: "Voir les fiches de travail",
  staff_tiers: "Niveaux du personnel",
  staff_tiers_hint: "Les niveaux de rémunération du garage et leur tarif horaire. Chaque membre du personnel est placé sur un niveau.",
  tier: "Niveau",
  tier_name: "Nom du niveau",
  tier_name_hint: "ex. Niveau 1 ou Senior",
  tier_name_required: "Donnez un nom au niveau",
  tier_rate_hint: "Saisissez un tarif horaire de 0 ou plus",
  hourly_rate: "Tarif horaire",
  per_hour: "/ heure",
  add_tier: "Ajouter un niveau",
  no_tiers: "Aucun niveau",
  no_tiers_hint: "Ajoutez les niveaux de rémunération de votre personnel, avec un tarif horaire pour chacun.",
  confirm_remove_tier: "Supprimer ce niveau ? Le personnel concerné n'aura plus de niveau.",
  role_and_tier: "Rôle et niveau",
  staff_role: "Rôle",
  role_owner: "Propriétaire",
  role_manager: "Responsable",
  role_mechanic: "Mécanicien",
  role_owner_hint: "Dirige le garage : réceptionne les véhicules, chiffre et approuve les travaux, remet les véhicules. Se connecte au panneau et à l'application avec le nom d'utilisateur ou le téléphone et le mot de passe ci-dessus.",
  role_manager_hint: "Réceptionne les véhicules, envoie les mécaniciens inspecter, approuve les travaux et remet les véhicules ; chiffre les travaux si le propriétaire l'autorise. Se connecte au panneau et à l'application.",
  role_mechanic_hint: "Inspecte les véhicules et réalise ses propres tâches. Se connecte uniquement à l'application.",
  managers_can_price: "Les responsables peuvent ouvrir les bons de travail et fixer les prix",
  managers_can_price_hint: "Désactivé : seul le propriétaire chiffre les bons de travail et envoie les devis",
  no_tier: "Aucun niveau",
  no_tiers_for_staff_hint: "Ajoutez des niveaux dans la configuration du garage pour y placer le personnel",
  staff_tier: "Niveau",
  add_currency: "Ajouter une devise",
  vehicle_specs: "Spécifications véhicule",
  vehicle_spec: "Spécification véhicule",
  vehicle_specs_subtitle: "Les spécifications proposées au client lors de l'ajout d'une voiture, ex. GCC ou américaine",
  add_vehicle_spec: "Ajouter une spécification",
  vehicle_spec_name_hint: "Affiché tel quel aux clients, ex. GCC",
  vehicle_spec_active_hint: "Une spécification inactive reste sur les voitures existantes mais n'est plus proposée",
  currency_symbol: "Symbole",
  currency_code_hint: "Identifiant court, par ex. USD ou AED",
  currency_symbol_hint: "Affiché à côté d'un montant, par ex. $",
  currency_code_min_hint: "Le code doit contenir au moins 2 caractères",
  currency_symbol_required_hint: "Le symbole est obligatoire",
  garage_currency_hint: "Les nouveaux garages démarrent en dollar américain",
  delivery: "Livraison",
  top_rated_hint: "Afficher ce garage dans la liste des mieux notés",
  top_rated_rank_hint:
    "Le plus petit s'affiche en premier. Laissez vide pour trier par note.",
  monday: "Lundi",
  tuesday: "Mardi",
  wednesday: "Mercredi",
  thursday: "Jeudi",
  friday: "Vendredi",
  saturday: "Samedi",
  sunday: "Dimanche",
  appointment: "Rendez-vous",
  items_per_page: "Éléments par page :",
  of: "sur",
  first_page: "Première page",
  last_page: "Dernière page",
  pw_length: "8+ caractères",
  pw_upper: "1 majuscule",
  pw_lower: "1 minuscule",
  pw_number: "1 chiffre",
  pw_symbol: "1 symbole",
  phone_hint: "Saisissez un numéro valide",
  phone_unique_hint: "Doit être unique parmi les garages",
  version_conflict_hint: "Ce garage a changé depuis l'ouverture. Appuyez de nouveau sur Enregistrer.",
  job_cards: "Fiches de travail",
  job_card: "Fiche de travail",
  job_cards_subtitle: "Véhicules reçus dans ce garage",
  no_job_cards: "Aucune fiche pour le moment",
  no_closed_job_cards: "Aucune fiche clôturée pour le moment",
  job_cards_history: "Historique",
  job_cards_history_subtitle: "Fiches déjà clôturées, de la plus récente à la plus ancienne",
  select_garage_first: "Sélectionnez un garage pour voir ses fiches",
  job_card_open: "Ouverte",
  job_card_in_progress: "En cours",
  job_card_closed: "Clôturée",
  dashboard: "Tableau de bord",
  dashboard_hint: "Vue d'ensemble de vos garages",
  dashboard_garage_hint: "Vue d'ensemble de votre garage",
  job_cards_by_status: "Fiches par statut",
  job_cards_open_hint: "encore ouvertes",
  upcoming_appointments: "Prochains rendez-vous",
  upcoming_hint: "à venir",
  appointments_by_status: "Rendez-vous par statut",
  no_appointments: "Aucun rendez-vous",
  pending_hint: "en attente de vous",
  booking_pending: "En attente",
  booking_accepted: "Acceptés",
  booking_started: "En cours",
  booking_finished: "Terminés",
  booking_rejected: "Refusés",
  booking_expired: "Expirés",
  recent_job_cards: "Fiches récentes",
  ratings_hint: "évaluations",
  occupation_hint: "L'occupation doit contenir au moins 3 caractères",
  worker_password_hint: "Au moins 6 caractères",
  worker_garage_hint: "Ce membre du personnel appartient à ce garage",
  access_app: "Accès à l'application",
  access_app_hint: "Autoriser ce membre du personnel à se connecter à l'application mobile",
  login_username: "Nom d'utilisateur",
  worker_username_hint:
    "Facultatif. Le membre du personnel peut se connecter avec ce nom au lieu du numéro de téléphone",
  username_format_hint:
    "3 à 30 caractères : lettres, chiffres, point, tiret bas ou tiret",
  appointment_detail: "Voiture et client",
  appointment_delete_booked:
    "Ce créneau a des réservations et ne peut pas être supprimé",
  cancel_bookings: "Annuler les réservations de ce créneau",
  confirm_cancel_bookings:
    "Annuler {0} réservation(s) sur ce créneau ? Les clients sont prévenus.",
  no_bookings_to_cancel:
    "Aucune réservation de ce créneau ne peut plus être annulée",
  previous_work_orders: "Ordres de travail précédents",
  no_previous_work_orders: "Aucune visite précédente pour cette voiture",
  no_bookings: "Aucune réservation sur ce rendez-vous",
  no_bookings_hint: "Personne n'a encore réservé ce créneau",
  booking_pending: "En attente",
  booking_accepted: "Accepté",
  booking_started: "En cours",
  booking_finished: "Terminé",
  booking_rejected: "Rejeté",
  booking_action_accept: "Accepter",
  booking_action_reject: "Rejeter",
  booking_action_start: "Démarrer",
  booking_action_finish: "Terminer",
  reject_reason_prompt: "Pourquoi ce rendez-vous est-il rejeté ? Le client le verra.",
  day_previous: "Jour précédent",
  day_next: "Jour suivant",
  day_today: "Aujourd'hui",
  dashboard_day_hint: "Aujourd'hui dans ce garage, et tous les rendez-vous à venir",
  overview: "APERÇU",
  minimize: "Réduire",
  expand: "Développer",
  q_pending_appointments: "Rendez-vous en attente",
  q_pending_appointments_hint: "en attente de vous, toutes dates",
  q_accepted_appointments: "Rendez-vous acceptés",
  q_accepted_appointments_hint: "confirmés, aujourd'hui et à venir",
  q_open_job_cards: "Fiches ouvertes",
  q_open_job_cards_hint: "au garage, fiche encore ouverte",
  q_awaiting_approval: "En attente d'accord",
  q_awaiting_approval_hint: "devis envoyé",
  q_in_progress_job_cards: "En cours",
  q_in_progress_job_cards_hint: "ordre de travail démarré",
  q_unpaid: "Impayés",
  q_unpaid_hint: "facture en attente",
  q_ready_to_deliver: "Prêts à livrer",
  q_ready_to_deliver_hint: "voiture en attente de son propriétaire",
  q_delivered: "Livrés",
  q_delivered_hint: "rendus aujourd'hui",
  queue_empty: "Rien dans cette file",
  queue_empty_hint: "Choisissez une autre file ci-dessus",
  no_work_order: "Aucun ordre de travail",
  no_work_order_for_card:
    "Cette fiche de travail n'a aucun ordre de travail à ouvrir.",
  payment: "Paiement",
  mark_as_paid: "Marquer comme payé",
  confirm_mark_paid_body: "Marquer la facture de {0} comme payée ?",
  no_work_order_to_settle: "Cette fiche n'a pas encore de rapport à régler.",
  payment_unpaid: "Impayé",
  payment_awaiting_cash: "Espèces à la remise",
  payment_paid: "Payé",
  dashboard_admin_hint: "Tous les garages de ce marchand, aujourd'hui et à venir",
  garages_by_load: "Garages",
  garages_by_load_hint: "les plus chargés d'abord — ouvrez-en un pour traiter sa journée",
  no_garages: "Aucun garage",
  overdue: "En retard",
  overdue_hint: "date de livraison dépassée",
  overdue_deliveries: "Livraison dépassée",
  overdue_deliveries_hint: "promises rendues et toujours sur place",
  no_overdue: "Aucun retard",
  no_overdue_hint: "Chaque voiture encore présente respecte sa date promise",
  col_appointments: "Rendez-vous",
  col_in_bay: "Dans l'atelier",
  col_handover: "Remise",
  garage_load: "En charge",
  garage_load_hint: "rendez-vous et voitures dans l'atelier",
  staff_short: "personnel",
  no_rating: "aucune évaluation",
  open_garage: "Ouvrir ce garage",
  q_short_pendingAppointments: "En attente",
  q_short_acceptedAppointments: "Acceptés",
  q_short_openJobCards: "Ouvertes",
  q_short_awaitingApproval: "Accord",
  q_short_inProgressJobCards: "En cours",
  q_short_unpaid: "Impayés",
  q_short_readyToDeliver: "Prêts",
  q_short_delivered: "Livrés",
  dashboard_unavailable: "Impossible de charger le tableau de bord",
  dashboard_unavailable_hint: "L'api n'a pas répondu pour ce garage. Vérifiez qu'elle est démarrée et à jour, puis réessayez.",
  retry: "Réessayer",
  start_service: "Démarrer le service",
  start_service_hint: "Réceptionner la voiture et ouvrir sa fiche",
  new_job_card: "Nouvelle fiche",
  new_job_card_hint: "Réceptionner ce véhicule dans le garage",
  job_card_received_by: "Réceptionné par",
  job_card_received_by_hint: "Le membre du personnel qui prend la voiture",
  job_card_notes: "Notes de réception",
  job_card_notes_hint: "Ce que le client a signalé en remettant la voiture",
  job_card_mileage_hint: "Relevé du compteur à l'arrivée",
  job_card_last_mileage: "Dernier relevé : {0} km{1}",
  job_card_mileage_lower_warning: "Inférieur au dernier relevé de {0} km",
  job_card_created: "Fiche ouverte",
  booking_not_found: "Ce rendez-vous est introuvable",
  no_workers_hint: "Ajoutez du personnel à ce garage avant d'ouvrir une fiche",
  open_job_card: "Ouvrir la fiche",
  dashboard_pick_garage_hint: "Choisissez un garage ci-dessus pour voir ses rendez-vous, fiches et raccourcis",

  // ── déroulé de l'ordre de travail ────────────────────
  wo_status_label: "État de l'ordre de travail",
  wo_type_priority: "Réparations prioritaires",
  wo_type_optional: "Réparations optionnelles",
  wo_type_service: "Prestations",
  wo_item_pending: "En attente",
  wo_item_approved: "Approuvé",
  wo_item_rejected: "Refusé",
  work_order: "Ordre de travail",
  work_order_not_found: "Cet ordre de travail est introuvable",
  back: "Retour",
  mechanic_note: "Note du mécanicien",
  mechanic_note_hint: "Note interne pour l'équipe du garage — le client ne la voit jamais…",
  save_note: "Enregistrer la note",
  note_saved: "Note enregistrée",
  work_items: "Éléments",
  no_items_yet: "Aucun élément. Ajoutez ce que l'inspection a relevé.",
  add_item: "Ajouter un élément",
  edit_item: "Modifier l'élément",
  remove_item: "Supprimer l'élément",
  add_sub_item: "Ajouter un sous-élément",
  add_choice_option: "Ajouter une option",
  add_choices: "Proposer un choix",
  client_picks_one: "Le client en choisit exactement une",
  choose_one: "Au choix",
  option: "Option",
  picked: "Choisi",
  auto_approved: "Auto",
  parent_item: "Élément parent",
  top_level_item: "— Élément principal —",
  item_type: "Type",
  service_part_name: "Prestation / pièce",
  brand_name: "Marque",
  estimated_cost: "Coût estimé",
  selling_price: "Prix de vente",
  cost_price: "Prix de revient",
  cost_price_short: "Revient : {0}",
  estimated_total: "Total estimé",
  total: "Total",
  client_note: "Note du client",
  item_name_required: "Le nom est obligatoire",
  item_added: "Élément ajouté",
  items_added: "Éléments ajoutés",
  from_garage_services: "Depuis les services du garage",
  no_garage_services: "Ce garage n'a pas encore de services.",
  no_sub_services: "Aucun sous-service pour ce service.",
  no_price_set: "Sans prix",
  add_selected: "Ajouter la sélection",
  item_updated: "Élément modifié",
  item_removed: "Élément supprimé",
  confirm_remove_item: "Supprimer cet élément ?",
  item_photos: "Photos",
  photo_before: "Avant",
  photo_after: "Après",
  photo_add: "Ajouter une photo",
  photo_replace: "Remplacer",
  photo_none: "Aucune photo",
  photo_uploaded: "Photo ajoutée",
  photo_removed: "Photo supprimée",
  confirm_remove_photo: "Supprimer cette photo ?",
  photos_after_start_only: "Les photos peuvent être ajoutées une fois le travail commencé",
  messages: "Messages",
  message_client: "Écrire au client",
  no_messages: "Aucun message",
  reply_placeholder: "Écrire au client…",
  send: "Envoyer",
  reply_sent: "Message envoyé",
  close: "Fermer",
  about_this_item: "À propos de cet élément",
  delivery_promised: "Promis au client",
  delivery_promised_to: "Promis au client — {0}",
  delivery_overdue: "En retard",
  delivery_due_today: "Pour aujourd'hui",
  delivery_date: "Date et heure de livraison",
  delivery_required: "Choisissez la date de restitution promise",
  delivery_day: "Jour de livraison",
  delivery_time: "Heure de livraison",
  delivery_time_required: "Choisissez une heure d'ouverture du garage",
  delivery_pick_day_first:
    "Choisissez un jour pour voir les heures de récupération",
  change_date: "Changer la date",
  delivery_updated: "Date de livraison mise à jour",
  assign: "Attribuer",
  change: "Modifier",
  assign_workers: "Attribuer ce travail",
  assign_workers_hint: "Qui s'en occupe — vous pourrez le transmettre plus tard",
  assign_later: "Attribuer plus tard",
  assignees_saved: "Travail attribué",
  no_workers_to_assign: "Ce garage n'a personne à qui attribuer le travail",
  assign_before_starting: "Attribuez le travail avant de le démarrer",
  garage_hours: "Horaires du garage",
  garage_break: "Pause",
  send_to_customer: "Envoyer au client",
  confirm_send_to_customer: "Envoyer ce rapport au client pour validation ?",
  work_order_sent: "Envoyé au client",
  waiting_client_review: "En attente de la validation du rapport par le client.",
  send_final_quote: "Envoyer le devis final",
  services: "Prestations",
  services_cost: "Coût des prestations",
  services_cost_hint: "Ce que le garage facture pour le travail lui-même. Le client le voit sur le devis final.",
  services_cost_required: "Saisissez le coût des prestations pour envoyer le devis final",
  services_cost_positive: "Le coût des prestations doit être supérieur à 0",
  quote_sent: "Devis final envoyé au client",
  resend_for_review: "Renvoyer pour validation",
  confirm_resend: "Renvoyer le rapport ? Le client conserve ses choix et peut les modifier avant de confirmer à nouveau.",
  resent_for_review: "Renvoyé au client",
  waiting_client_accept: "Devis final envoyé. En attente de l'acceptation du client.",
  recall_quote: "Renvoyer pour validation",
  confirm_recall_quote: "Le client ne verra plus ce devis final. Modifiez le prix, la date ou le technicien assigné, puis renvoyez-le quand vous êtes prêt.",
  quote_recalled: "Devis retiré — apportez vos modifications puis renvoyez-le.",
  start_work: "Démarrer le travail",
  work_started: "Travail démarré",
  mark_as_done: "Marquer comme terminé",
  confirm_finish: "Marquer ce travail comme terminé ?",
  work_finished: "Travail terminé",
  ready_to_deliver: "Prêt à livrer",
  confirm_ready_to_deliver: "Garer cette voiture en attente du client ?",
  marked_ready: "Garée en attente du client",
  awaiting_pickup: "La voiture est garée et attend son propriétaire.",
  mark_delivered: "Marquer comme livré",
  vehicle_delivered: "Véhicule remis",
  work_order_delivered_note: "Le client a récupéré son véhicule. Ce travail est clos.",
  work_order_declined_note: "Le client a refusé tous les éléments, ce rapport est clos.",
  payment_summary: "Facture",
  parts_total: "Pièces et réparations",
  labor_total: "Main-d'œuvre",
  net_total: "Total à payer",
  cash_due_hint: "Le client a choisi de payer en espèces au comptoir",
  confirm_cash_collected: "Confirmer l'encaissement",
  confirm_cash_collected_body: "Confirmez-vous avoir encaissé {0} en espèces ?",
  payment_confirmed: "Paiement confirmé",
  settle_invoice_first: "Réglez la facture avant de remettre le véhicule",
  confirm: "Confirmer",
  // work order lead steps and the job card's actions, as in the app
  approve_for_work: "Approuver les travaux",
  approve_for_work_hint: "Listez les pièces nécessaires. Les mécaniciens cochent chacune à sa réception, puis démarrent les travaux.",
  work_approved: "Travaux approuvés pour les mécaniciens",
  assign_mechanics_first: "Attribuez d'abord des mécaniciens",
  assign_mechanics_first_hint: "Personne n'est encore sur ce travail. Choisissez les mécaniciens qui le réaliseront, puis approuvez-le.",
  assign_mechanics: "Attribuer des mécaniciens",
  unpriced_items_title: "Éléments sans prix",
  unpriced_items_message: "{0} élément(s) sans prix pour le moment :",
  unpriced_items_hint: "Le client les verra sans prix.",
  send_anyway: "Envoyer quand même",
  waiting_for_mechanic_start: "Approuvé — en attente que le mécanicien coche les pièces et démarre",
  edit_parts_list: "Modifier la liste des pièces",
  parts_list: "Liste des pièces",
  parts_progress: "{0} sur {1} reçues",
  no_parts_needed: "Aucune pièce nécessaire pour ce travail",
  part_name: "Pièce",
  part_qty: "Qté",
  add_part: "Ajouter une pièce",
  remove_part: "Retirer la pièce",
  confirm_remove_part: "Retirer cette pièce de la liste ?",
  part_removed: "Pièce retirée",
  requested_by: "Demandée par {0}",
  for_task: "Pour {0}",
  tasks_progress: "{0} sur {1} tâches terminées",
  tasks_progress_hint: "Chaque mécanicien marque ses tâches terminées dans l'application ; la dernière termine le travail.",
  final_check_ready: "Inspection finale à effectuer",
  waiting_final_check: "Toutes les tâches sont terminées — vérifiez la voiture, puis prévenez le client",
  by_author: "Par {0}",
  mechanic: "Mécanicien",
  no_mechanic_assigned: "Aucun mécanicien",
  hours_needed: "Heures nécessaires",
  hours_short: "{0} h",
  warranty: "Garantie",
  no_warranty: "Sans garantie",
  months_count: "{0} mois",
  task_done: "Terminé",
  waiting_for_part: "En attente d'une pièce",
  send_to_inspect: "Envoyer en inspection",
  inspectors: "Inspecteurs",
  choose_inspectors: "Choisissez les mécaniciens qui inspecteront la voiture",
  no_mechanics_on_staff: "Ce garage n'a aucun mécanicien",
  inspectors_assigned: "Envoyé en inspection",
  close_job_card: "Clôturer la fiche",
  confirm_close_job_card: "Clôturer cette fiche ? La voiture est rendue et son ordre de travail est clôturé.",
  job_card_closed_done: "Fiche clôturée",
  create_work_order: "Créer l'ordre de travail",
  work_order_issues: "Ordre de travail — {0} sur {1} approuvés",
  previous_visits: "Visites précédentes",
  no_issues_recorded: "Aucun problème enregistré",
  confirm_remove_attachment: "Retirer cette pièce jointe de la fiche ?",
  attachment_removed: "Pièce jointe retirée",
  photo_uploaded_card: "Pièce jointe ajoutée",
  report_monthly: "Rapport mensuel",
  report_cars_received: "Véhicules reçus",
  report_cars_fixed: "Véhicules réparés",
  report_tasks: "Tâches",
  report_tasks_done: "tâches terminées",
  report_plate: "Plaque",
  report_vehicle: "Véhicule",
  report_total: "Total",
  report_cars: "véhicules",
};

export default lang;
